import {
  CREATE_CHAT,
  CREATE_CHAT_SUCCESS,
  CREATE_CHAT_FAIL,
  CREATE_CHAT_RESET,
  GET_CHAT,
  GET_CHAT_SUCCESS,
  GET_CHAT_FAIL,
  GET_CHAT_RESET,
  GET_ALL_CHATS,
  GET_ALL_CHATS_SUCCESS,
  GET_ALL_CHATS_FAIL,
  GET_ALL_CHATS_RESET,
  GET_CHATS_BY_PROJECT,
  GET_CHATS_BY_PROJECT_SUCCESS,
  GET_CHATS_BY_PROJECT_FAIL,
  GET_CHATS_BY_PROJECT_RESET,
  DELETE_CHAT,
  DELETE_CHAT_SUCCESS,
  DELETE_CHAT_FAIL,
  DELETE_CHAT_RESET,
  UPDATE_CHAT_TITLE,
  UPDATE_CHAT_TITLE_SUCCESS,
  UPDATE_CHAT_TITLE_FAIL,
  UPDATE_CHAT_TITLE_RESET,
  STREAM_MESSAGE_CHUNK,
  STREAM_MESSAGE_COMPLETE,
  STREAM_MESSAGE_ERROR,
  STREAM_MESSAGE_RESET,
  GET_CHAT_SHARES,
  GET_CHAT_SHARES_SUCCESS,
  GET_CHAT_SHARES_FAIL,
  GET_CHAT_SHARES_RESET,
  SHARE_CHAT,
  SHARE_CHAT_SUCCESS,
  SHARE_CHAT_FAIL,
  SHARE_CHAT_RESET,
  UPDATE_CHAT_SHARE,
  UPDATE_CHAT_SHARE_SUCCESS,
  UPDATE_CHAT_SHARE_FAIL,
  UPDATE_CHAT_SHARE_RESET,
  REMOVE_CHAT_SHARE,
  REMOVE_CHAT_SHARE_SUCCESS,
  REMOVE_CHAT_SHARE_FAIL,
  REMOVE_CHAT_SHARE_RESET,
} from '../actions/chatAction';

const initialState = {
  createChatState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getChatState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getAllChatsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getChatsByProjectState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteChatState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateChatTitleState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  streamMessageState: {
    apiState: 'idle',
    content: '',
    isStreaming: false,
    error: null,
  },
  getChatSharesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  shareChatState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  updateChatShareState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  removeChatShareState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHAT:
      return {
        ...state,
        createChatState: {
          ...state.createChatState,
          apiState: 'loading',
        },
      };
    case CREATE_CHAT_SUCCESS:
      return {
        ...state,
        createChatState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chat created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_CHAT_FAIL:
      return {
        ...state,
        createChatState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create chat',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_CHAT_RESET:
      return {
        ...state,
        createChatState: initialState.createChatState,
      };

    case GET_CHAT:
      return {
        ...state,
        getChatState: {
          ...state.getChatState,
          apiState: 'loading',
        },
      };
    case GET_CHAT_SUCCESS:
      return {
        ...state,
        getChatState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chat retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CHAT_FAIL:
      return {
        ...state,
        getChatState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch chat',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CHAT_RESET:
      return {
        ...state,
        getChatState: initialState.getChatState,
      };

    case GET_ALL_CHATS:
      return {
        ...state,
        getAllChatsState: {
          ...state.getAllChatsState,
          apiState: 'loading',
        },
      };
    case GET_ALL_CHATS_SUCCESS:
      return {
        ...state,
        getAllChatsState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chats retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_ALL_CHATS_FAIL:
      return {
        ...state,
        getAllChatsState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch chats',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_ALL_CHATS_RESET:
      return {
        ...state,
        getAllChatsState: initialState.getAllChatsState,
      };

    case GET_CHATS_BY_PROJECT:
      return {
        ...state,
        getChatsByProjectState: {
          ...state.getChatsByProjectState,
          apiState: 'loading',
        },
      };
    case GET_CHATS_BY_PROJECT_SUCCESS:
      return {
        ...state,
        getChatsByProjectState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chats retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CHATS_BY_PROJECT_FAIL:
      return {
        ...state,
        getChatsByProjectState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch chats',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CHATS_BY_PROJECT_RESET:
      return {
        ...state,
        getChatsByProjectState: initialState.getChatsByProjectState,
      };

    case DELETE_CHAT:
      return {
        ...state,
        deleteChatState: {
          ...state.deleteChatState,
          apiState: 'loading',
        },
      };
    case DELETE_CHAT_SUCCESS:
      return {
        ...state,
        deleteChatState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chat deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_CHAT_FAIL:
      return {
        ...state,
        deleteChatState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete chat',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_CHAT_RESET:
      return {
        ...state,
        deleteChatState: initialState.deleteChatState,
      };

    case UPDATE_CHAT_TITLE:
      return {
        ...state,
        updateChatTitleState: {
          ...state.updateChatTitleState,
          apiState: 'loading',
        },
      };
    case UPDATE_CHAT_TITLE_SUCCESS:
      return {
        ...state,
        updateChatTitleState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chat title updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_CHAT_TITLE_FAIL:
      return {
        ...state,
        updateChatTitleState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update chat title',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_CHAT_TITLE_RESET:
      return {
        ...state,
        updateChatTitleState: initialState.updateChatTitleState,
      };

    case STREAM_MESSAGE_CHUNK:
      return {
        ...state,
        streamMessageState: {
          apiState: 'streaming',
          content: state.streamMessageState.content + (action.chunk?.content || ''),
          isStreaming: true,
          error: null,
        },
      };
    case STREAM_MESSAGE_COMPLETE:
      return {
        ...state,
        streamMessageState: {
          ...state.streamMessageState,
          apiState: 'success',
          isStreaming: false,
        },
      };
    case STREAM_MESSAGE_ERROR:
      return {
        ...state,
        streamMessageState: {
          ...state.streamMessageState,
          apiState: 'error',
          isStreaming: false,
          error: action.error,
        },
      };
    case STREAM_MESSAGE_RESET:
      return {
        ...state,
        streamMessageState: initialState.streamMessageState,
      };

    // Chat Sharing
    case GET_CHAT_SHARES:
      return {
        ...state,
        getChatSharesState: {
          ...state.getChatSharesState,
          apiState: 'loading',
        },
      };
    case GET_CHAT_SHARES_SUCCESS:
      return {
        ...state,
        getChatSharesState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Shares retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CHAT_SHARES_FAIL:
      return {
        ...state,
        getChatSharesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch shares',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CHAT_SHARES_RESET:
      return {
        ...state,
        getChatSharesState: initialState.getChatSharesState,
      };

    case SHARE_CHAT:
      return {
        ...state,
        shareChatState: {
          ...state.shareChatState,
          apiState: 'loading',
        },
      };
    case SHARE_CHAT_SUCCESS:
      return {
        ...state,
        shareChatState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Chat shared successfully',
          errors: action.response.errors || null,
        },
      };
    case SHARE_CHAT_FAIL:
      return {
        ...state,
        shareChatState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to share chat',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case SHARE_CHAT_RESET:
      return {
        ...state,
        shareChatState: initialState.shareChatState,
      };

    case UPDATE_CHAT_SHARE:
      return {
        ...state,
        updateChatShareState: {
          ...state.updateChatShareState,
          apiState: 'loading',
        },
      };
    case UPDATE_CHAT_SHARE_SUCCESS:
      return {
        ...state,
        updateChatShareState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Share updated successfully',
          errors: action.response.errors || null,
        },
      };
    case UPDATE_CHAT_SHARE_FAIL:
      return {
        ...state,
        updateChatShareState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to update share',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case UPDATE_CHAT_SHARE_RESET:
      return {
        ...state,
        updateChatShareState: initialState.updateChatShareState,
      };

    case REMOVE_CHAT_SHARE:
      return {
        ...state,
        removeChatShareState: {
          ...state.removeChatShareState,
          apiState: 'loading',
        },
      };
    case REMOVE_CHAT_SHARE_SUCCESS:
      return {
        ...state,
        removeChatShareState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Share removed successfully',
          errors: action.response.errors || null,
        },
      };
    case REMOVE_CHAT_SHARE_FAIL:
      return {
        ...state,
        removeChatShareState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to remove share',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case REMOVE_CHAT_SHARE_RESET:
      return {
        ...state,
        removeChatShareState: initialState.removeChatShareState,
      };

    default:
      return state;
  }
};

export default chatReducer;
